module.exports = __webpack_public_path__ + "a58244d267f28daf93202700167774d2.svg";